var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9178 1.44852H15.3112V0H13.6448V1.45182H7.34895V0H5.68253V1.45182H5.07595C2.27636 1.44851 0 3.7106 0 6.48856V15.9601C0 18.7381 2.27636 21 5.07914 21H15.9209C18.7204 21 21 18.7412 21 15.9601V6.48856C21 3.7106 18.7236 1.44865 15.9209 1.44865L15.9178 1.44852ZM19.3306 15.96C19.3306 17.8252 17.8008 19.3464 15.9178 19.3464H5.07949C3.19976 19.3464 1.66666 17.8285 1.66666 15.96V8.56857H19.3306V15.96ZM19.3306 6.91513H1.66666V6.48852C1.66666 4.62331 3.19644 3.10205 5.07949 3.10205H5.68607V4.59686H7.3525V3.10205H13.6483V4.59686H15.3147V3.10205H15.9213C17.801 3.10205 19.3342 4.62001 19.3342 6.48852V6.91513H19.3306Z",
    fill: "#093179"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate1);
export default __webpack_public_path__ + "static/media/date-1.7575911c4913c93a2bf058057cb62465.svg";
export { ForwardRef as ReactComponent };